// extracted by mini-css-extract-plugin
module.exports = {"section":"contact_section__ySHW1","container":"contact_container__GPwc8","imgBox":"contact_imgBox__S5eFF","textPortion":"contact_textPortion__z8wvk","image":"contact_image__BtEGp"};